





















import Vue from 'vue';
import { mapState } from 'vuex';
import Helpers from '../mixins/helpers';
import Sliders from '@/components/dumb/Sliders.vue'
import HeadingColumns from '@/components/dumb/HeadingColumns.vue';
import OfferGroup from './OfferGroup.vue';
import Analytics from '@/mixins/analytics';
import { IHeadingColumnGroupItem, IOffersItem } from '../types';
import { EOfferType } from '../enums';
export default Vue.extend({
	name: 'CheckoutCash',
	components: {
		Sliders, 
		HeadingColumns, 
		OfferGroup
	}, 
	computed: {
		...mapState({
			app(): any { return this.$store.state.app },
			dealer(): any { return this.$store.state.dealer },
			vehicle(): any { return this.$store.state.vehicle }
		}), 
		hasDriveawayOffer(): boolean {
			const arr = this.vehicle.offers.filter((o: IOffersItem) => o.offerType == EOfferType.VehiclePrice);
			return !!arr.length;
		},
		showPriceDisclaimer(): boolean{
			return this.$store.getters.showPriceDisclaimer;
		},
		vehicleFinalPrice(): number {
            return this.$store.getters.vehicleFinalPrice;
        },
		vehicleOnCollectionPrice(): string {
			const remain = (this.vehicleFinalPrice as number) - this.app.cashDeposit;
			return Helpers.getFormattedPrice(remain);
		},
		vehicleOnCollectionItem(): IHeadingColumnGroupItem {
			const remain = (this.vehicleFinalPrice as number) - this.app.cashDeposit;
			return {
				subHeading: 'On Collection', 
				heading: this.vehicleOnCollectionPrice
			};
		},
		vehiclePriceItems(): Array<IHeadingColumnGroupItem> {
			return [
				{
					subHeading: 'Total Driveaway', 
					heading: Helpers.getFormattedPrice(this.vehicleFinalPrice as number),
					sup: this.vehicle.disclaimerKey
				},
				this.vehicleOnCollectionItem, 
				{
					disclaimer: this.showPriceDisclaimer
				}
			];
		}, 
		slidersCash(): Array<any> {
			return [
				{
					// id: 3,
					type: 'currency',
					title: '', 
					description: '',
					disabled: false,
					min: this.dealer.depositMinimum, 
					max: this.dealer.cashDepositMaximum, 
					interval: 50,
					val: this.app.cashDeposit
				}
			];
		}
	}, 
	methods: {
		handleSliderUpdate(data: any): void {
			const s = data.data;
			const o = data.analytics;
			this.$store.commit('setApp', {
				cashDeposit: s[0].val
			});
			Analytics.sendEvent({
				'event':'adjustCash',
				'depositAmount': o.val
			});
		}
	}
});
